import React from "react"

import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view"
import {BREAKDOWN_ALL_VALUES} from "../../../../gd-modules/tasks-view/core/@const"
import {ColorPalette} from "../../../color-coding/color-coding"

export default function FieldDropdown_GroupByView(props: FieldQuickFilterViewProps) {

    const {value} = props

    let icon = null
    let label = ''

    switch (value) {
        case BREAKDOWN_ALL_VALUES:
            label = 'All values'
            break
        case null:
        case 'null':
            label = 'Not selected'
            break

        default:
            const option = props.field._getOption(value)
            if (option) {
                const optionColor = _.get(option, 'color', null)

                if (optionColor) {
                    const iconClasses = Classes("group-icon m-r-10", props.field.icon)

                    const iconStyle = {
                        color: gd.skin.colors.mainColor({
                            colorNumber: optionColor,
                            corePalette: ColorPalette.CORE
                        })
                    }

                    icon = (
                        <div className  = {iconClasses}
                             style      = {iconStyle}
                        />
                    )
                }
                label = option.label
            } else {
                label = value
            }
    }

    const classes = Classes("ui5-group-by-view", props.className)

    return (
        <div className={classes}>
            {icon}
            <div className="name">{label}</div>
        </div>
    )


}